import { render, staticRenderFns } from "./ParticipateView.vue?vue&type=template&id=19ef54fc&scoped=true&"
import script from "./ParticipateView.vue?vue&type=script&lang=js&"
export * from "./ParticipateView.vue?vue&type=script&lang=js&"
import style0 from "./ParticipateView.vue?vue&type=style&index=0&id=19ef54fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ef54fc",
  null
  
)

export default component.exports